import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import AI_GET_PROMPT_REPORT_QUERY from '../queries/AI_GET_PROMPT_REPORT_QUERY';
import { getFormattedDate } from '../../utils';

const useAIGetPromptReport = ( promptId, reportId ) => {    
    const { data, loading, error } = useQuery( AI_GET_PROMPT_REPORT_QUERY, { 
        variables: {
            promptId,
            reportId
        },
        fetchPolicy: 'network-only' 
    } );

    const promptReport = useMemo( () => {
        if ( loading || error || !data?.promptReport ) {
            return undefined;
        }

        try {
            return {
                ...data.promptReport,
                createdAt: getFormattedDate( data.promptReport.createdAt ),
            };
        } catch ( parseError ) {
            console.error( 'Error parsing prompt report:', parseError );
            return undefined;
        }
    }, [ data, loading, error ] );
   
    return useMemo( () => ( {
        promptReport,
        promptReportError: error,
        promptReportLoading: loading,
    } ), [ promptReport, error, loading ] );
};

export default useAIGetPromptReport;
